import { Icon } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import messages from './MissingRequiredDocWarning.messages';
import styles from '../TradingHistory.module.css';

const MissingRequiredDocWarning = ({ dataTestId }: { dataTestId: string }) => {
    return (
        <div className={styles.errorContainer} data-testid={dataTestId}>
            <Icon
                width={20}
                height={20}
                icon="exclamationTriangleOutline"
                className={styles.errorIcon}
            />
            <FormattedMessage {...messages.required} />
        </div>
    );
};

export default MissingRequiredDocWarning;
